/**
 * .main-header is always fixed. Near the top it tracks scroll like it was
 * in flow; after that it hides on scroll-down and slides back in on scroll-up.
 */
(function () {
	const header = document.querySelector('.main-header');
	const spacer = document.querySelector('.main-header-spacer');
	if (!header) {
		return;
	}

	const THRESHOLD = 8;
	let lastY = window.scrollY;
	let ticking = false;
	let trackingPage = lastY < header.offsetHeight;

	function syncSpacerHeight() {
		if (!spacer) {
			return;
		}
		spacer.style.height = header.offsetHeight + 'px';
	}

	function isExpanded() {
		return header.classList.contains('expanded');
	}

	function lockToPage(y) {
		header.classList.add('is-scrolling-with-page');
		header.classList.remove('is-hidden');
		header.style.setProperty('--header-shift', -y + 'px');
		header.inert = false;
	}

	function releaseFromPage() {
		header.classList.remove('is-scrolling-with-page');
		header.style.removeProperty('--header-shift');
	}

	function show() {
		header.classList.remove('is-hidden');
		header.inert = false;
	}

	function hide() {
		if (isExpanded()) {
			return;
		}
		header.classList.add('is-hidden');
		header.inert = true;
	}

	function update() {
		const y = Math.max(0, window.scrollY);
		const delta = y - lastY;

		if (isExpanded()) {
			trackingPage = false;
			releaseFromPage();
			show();
			lastY = y;
			ticking = false;
			return;
		}

		if (y < header.offsetHeight) {
			if (trackingPage || y === 0) {
				trackingPage = true;
				lockToPage(y);
			} else {
				releaseFromPage();
				show();
			}
			lastY = y;
			ticking = false;
			return;
		}

		trackingPage = false;
		releaseFromPage();

		if (Math.abs(delta) < THRESHOLD) {
			ticking = false;
			return;
		}

		if (delta > 0) {
			hide();
		} else {
			show();
		}

		lastY = y;
		ticking = false;
	}

	syncSpacerHeight();
	update();

	if (window.ResizeObserver) {
		new ResizeObserver(syncSpacerHeight).observe(header);
	} else {
		window.addEventListener('resize', syncSpacerHeight);
	}

	window.addEventListener(
		'scroll',
		function () {
			if (!ticking) {
				window.requestAnimationFrame(update);
				ticking = true;
			}
		},
		{ passive: true },
	);
})();
